// import router from '@/router'
import axios from '@/plugins/axios'
import i18n from '@/plugins/vue-i18n'

/**
 * Get v-money format
 */
const getMoneyFormat = (currencyType) => {
  switch (currencyType) {
    case 'USD':
      return {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      }
    case 'EUR':
      return {
        decimal: ',',
        thousands: '.',
        prefix: '€ ',
        precision: 2,
        masked: false
      }
    default:
      return {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
  }
}

/**
 * Get zicpode data
 * @param {*} zipcode
 */
const getZipcodeData = async zipcode => {
  if (zipcode.length <= 0) return false
  try {
    const response = await axios.get('addresses/zipcode', {
      params: {
        zipcode: zipcode
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get the error response and create the error array
 */
const parseErrorResponseToArray = error => {
  let data
  if (error.response && error.response.data && error.response.data.errors) {
    data = error.response.data.errors
  } else if (error.errors) {
    data = error.errors
  } else if (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')) {
    // Requisição estourou o tempo limite: a operação pode ter sido concluída no servidor
    if (i18n.locale === 'es') {
      data = ['La solicitud tardó más de lo esperado. Verifica el estado en la lista antes de intentar de nuevo']
    } else if (i18n.locale === 'en') {
      data = ['The request took longer than expected. Check its status in the list before trying again']
    } else {
      data = ['A requisição demorou mais que o esperado. Confira o status na listagem antes de tentar novamente']
    }
  } else {
    if (i18n.locale === 'es') {
      data = ['Si tiene un problema al procesar una solicitud, tente novamente más tarde']
    } else if (i18n.locale === 'en') {
      data = ['There was a problem processing the request, please try again later']
    } else {
      data = ['Houve um problema ao processar a requisição, tente novamente mais tarde']
    }
  }
  return data
}

/**
 * Register vuex module
 *
 */
const registerVuexModule = (rootStore, moduleName, store) => {
  if (!(moduleName in rootStore._modules.root._children)) {
    rootStore.registerModule(moduleName, store)
  }
}

export {
  getMoneyFormat,
  getZipcodeData,
  parseErrorResponseToArray,
  registerVuexModule
}
